export const formatToJPY = (amount: number) => {
  if (amount === null || typeof amount === 'undefined') {
    return '';
  }
  return new Intl.NumberFormat('ja-JP', { currency: 'JPY', style: 'currency' }).format(amount);
};
